module.exports = __webpack_public_path__ + "static/media/metro_1.14d657e7.mp3";